export const APP_LOGO_URL = "/BMC_MUMBAI_LOGO.png";
export const APP_LOGO_ALT = "BMC Mumbai";
export const APP_BRAND_TITLE = "BMC | Waterlogging";
